export default __webpack_public_path__ + "static/media/mx.4a1f4d91.svg";